import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import Modal from 'react-bootstrap/Modal';

import '../../css/modal.css';
import { useSelector } from "react-redux";

const ModalTermos = (props) => {const { t } = usePreferences();
  const { processo_name, showModal, setShowModal, termos } = props;
  const user = useSelector((state) => state.AppReducer.user);

  return (
    termos != null && <Modal
      show={showModal == true}
      dialogClassName="modal_width"
      onHide={() => setShowModal(false)}>

            <Modal.Header closeButton closeLabel=''><Modal.Title>{`${t("label_terms")} `}{user.empresa == null || user.empresa.change_text == false ? t("legacy_da_instituicao") : t("legacy_do_processo")} {processo_name}<br /></Modal.Title></Modal.Header>
            <Modal.Body>
                <div className="custom_scrollbar">

                    <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: termos }}>

                    </div>
                </div>

            </Modal.Body>
        </Modal>);


};

export default ModalTermos;
